import React, { useState } from "react";
import { ModalUpdateBioContainer } from "./styled";
import { Upload, UploadFile, Avatar, message } from "antd";
import type { UploadProps } from "antd/es/upload";
import type { GetProp } from "antd";
import { ButtonCommon } from "../../../Layout/styled";
import { Controller, useForm } from "react-hook-form";
import InputCommon from "../../../components/Common/Input";
import { AVAX_API } from "../../../services/api/indexV2";
import toast from "react-hot-toast";
import { fetchUserProfile } from "../../../store/features/profileSlice";
import { useDispatch } from "../../../store/store";

const ModalUpdateBio = ({ userProfile, setOpenModalUpdateBio }: any) => {
  const dispatch = useDispatch();
  const { control, handleSubmit } = useForm({ mode: "onChange" });

  const onSubmit = async (data: any) => {
    const params = {
      bio: data.bio,
    };
    const res = await AVAX_API.updateProfile(params);
    if (res?.status === 200) {
      toast.success("Update Success");
      dispatch(fetchUserProfile());
      setOpenModalUpdateBio(false);
    }
  };

  return (
    <ModalUpdateBioContainer>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="bio"
          control={control}
          render={({ field }: any) => (
            <InputCommon
              {...field}
              placeHolder={
                userProfile?.user?.bio ? userProfile?.user?.bio : "No bio"
              }
            />
          )}
        />
        <ul className="list-buttons">
          <ButtonCommon>Save</ButtonCommon>
        </ul>
      </form>
    </ModalUpdateBioContainer>
  );
};

export default ModalUpdateBio;
